import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/main/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'forgotPassword',
    loadComponent: () =>
      import(
        './core/authentication/components/forgot-password/forgot-password-wrapper.component'
      ).then((m) => m.ForgotPasswordWrapperComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import(
        './core/authentication/components/reset-password/reset-password.component'
      ).then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'raterLogin/:raterGuid',
    loadComponent: () =>
      import('./core/authentication/components/rater-login/rater-login.component').then(
        (m) => m.RaterLoginComponent,
      ),
  },
  {
    path: 'raterTest',
    loadComponent: () =>
      import('./features/admin/components/rater-test/rater-test.component').then(
        (m) => m.RaterTestComponent,
      ),
  },
  {
    path: 'rater',
    loadChildren: () =>
      import('./features/rater/rater.routes').then((m) => m.raterRoutes),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'participant',
    loadChildren: () =>
      import('./features/participant/participant.routes').then((m) => m.participantRoutes),
  },
  {
    path: 'client',
    loadChildren: () =>
      import('./features/client-admin/client-admin.routes').then((m) => m.clientAdminRoutes),
  },
  {
    path: 'question',
    loadChildren: () =>
      import('./features/admin-question/admin-question.routes').then(
        (m) => m.adminQuestionRoutes,
      ),
  },
  {
    path: 'ui',
    loadComponent: () =>
      import('./features/main/home/ui-test/ui-test.component').then(
        (m) => m.UiTestComponent,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
